import { compressSync } from 'fflate';
import { WebSocket as NodeWebSocket } from 'ws';
import { fromTypedJSON, toTypedJSON } from './serialization.js';
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const encoder = new TextEncoder();
const isBrowser = typeof window !== 'undefined';
/**
 * Typed object-based wrapper for a WebSocket
 */
export class TypedWebSocket {
    ws;
    constructor(address, query) {
        // Encode query object as compressed JSON in the URL
        const encoded = encoder.encode(toTypedJSON(query));
        const compressed = compressSync(encoded);
        const queryString = base64urlEncode(compressed);
        address += `?${queryString}`;
        if (isBrowser) {
            // Browser
            this.ws = new WebSocket(address);
        }
        else {
            // Node.js
            this.ws = new NodeWebSocket(address);
        }
        this.ws.addEventListener('error', (err) => {
            console.error('PubSub WebSocket error:', err);
        });
    }
    async ready() {
        const open = (isBrowser ? WebSocket : NodeWebSocket).OPEN;
        if (this.ws.readyState === open) {
            await sleep(200);
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            this.ws.addEventListener('open', async () => {
                await sleep(200);
                resolve();
            }, { once: true });
            this.ws.addEventListener('close', () => reject(new Error('WebSocket closed before opening')), {
                once: true,
            });
        });
    }
    /**
     * Sends a JSON-serializable object
     * @param obj Object to send
     */
    sendObject(obj) {
        this.ws.send(toTypedJSON(obj));
    }
    /**
     * Listens for an incoming message, deserializing JSON and validating the object
     * @ param cls Constructor
     * @param cb Callback to handle the object
     */
    listen(ctr, cb) {
        this.ws.onmessage = (event) => {
            const data = event.data;
            try {
                const model = fromTypedJSON(ctr, data.toString());
                if (model !== undefined) {
                    cb(model);
                }
                else {
                    console.warn(`Received unrecognized websocket message: ${data.toString()}`);
                }
            }
            catch {
                console.warn(`Received invalid websocket message: ${data.toString()}`);
            }
        };
    }
    onClose(cb) {
        this.ws.onclose = cb;
    }
    async close() {
        await sleep(1000); // Allow websocket to flush
        this.ws.close();
    }
}
function base64urlEncode(input) {
    return btoa(String.fromCharCode(...input))
        .replace(/\+/g, '-') // Convert '+' to '-'
        .replace(/\//g, '_') // Convert '/' to '_'
        .replace(/=+$/, ''); // Remove padding
}
//# sourceMappingURL=ws.js.map